<template>
  <!-- for absolute links, we simple want to open them in a new tab -->
  <a v-if="isSignUpLink" :href="computedHref" v-bind="$attrs" type="button" aria-label="Sign Up Link"><slot /></a>
  <a
    v-else-if="!isInternalLink"
    :href="computedHref"
    target="_blank"
    v-bind="$attrs"
    aria-label="Documentation External Link"
    ><slot
  /></a>
  <router-link v-else :to="internalLink" v-bind="$attrs" aria-label="Documentation Internal Link"><slot /></router-link>
  <!-- we want to use the vue-router to handle internal links  -->
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { isRelativeUrl } from '@/utils/url';
import { replaceVariablesInLinkWrapper } from '@/utils/linkWrapperUrl';

const props = defineProps({
  href: { type: String, required: true },
});

const computedHref = computed(() => replaceVariablesInLinkWrapper(decodeURI(props.href)));
const isInternalLink = computed(() => isRelativeUrl(computedHref.value));
const internalLink = computed(() =>
  // removing appending slash from the relative urls as it is causing infinite call to fbevent.js
  isInternalLink.value ? computedHref.value.replace(/\/$/, '') : computedHref.value
);
const isSignUpLink = computed(() => computedHref.value === '/sign-up');
</script>
<style scoped lang="scss">
a {
  color: var(--vvd-color-cta-600);
}
</style>
